import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import { ShowCharsLimt } from '../common'
import { useToSetCharsLimit } from '../common/hooks'
import CKEditor from '../../components/editor'
import { Essentials } from '@ckeditor/ckeditor5-essentials'
import { Paragraph } from '@ckeditor/ckeditor5-paragraph'
import { ListProperties } from '@ckeditor/ckeditor5-list'
import sanitizeHtml from 'sanitize-html'

const CustomBody = ({
  maxCharsInBody,
  minCharsInBody,
  disabled,
  placeholder,
}) => {
  const [error, setError] = useState(null)

  const {
    totalChars: totalCharsInBodyText,
    updateCharsLength: updateCharsInBodyText,
  } = useToSetCharsLimit()
  const {
    values: { body },
    handleBlur,
    handleChange,
  } = useFormikContext()

  const editorConfiguration = {
    licenseKey: 'GPL',
    plugins: [Essentials, Paragraph, ListProperties],
    toolbar: ['|', 'bulletedList', 'numberedList'],
    config: {
      resize_maxHeight: 100,
    },
  }

  useEffect(() => {
    const sanitized = sanitizeHtml(body || '', {
      allowedTags: [],
      allowedAttributes: {},
    })
    updateCharsInBodyText(sanitized)
    setError(
      sanitized.length > maxCharsInBody
        ? `Body must be less than ${maxCharsInBody} characters.`
        : sanitized.length < minCharsInBody && sanitized.length !== 0
        ? `Body must be at least ${minCharsInBody} characters long.`
        : null,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [body])
  return (
    <>
      <label>Signup Page Description</label>
      <CKEditor
        name='body'
        data={body || ''}
        onChange={(e, editor) => {
          const data = editor.getData()
          const sanitizedData = sanitizeHtml(data, {
            allowedTags: [],
            allowedAttributes: {},
          })
          handleChange({ target: { name: 'body', value: data } })
          updateCharsInBodyText(sanitizedData)
          setError(null)
        }}
        placeholder={placeholder}
        onBlur={(event, editor) => {
          const data = editor.getData()
          const sanitizedData = sanitizeHtml(data, {
            allowedTags: [],
            allowedAttributes: {},
          })
          handleBlur({ target: { name: 'body', value: data } })
          updateCharsInBodyText(sanitizedData)
          const headerError =
            sanitizedData?.length > maxCharsInBody
              ? `Body must be less than ${maxCharsInBody} characters.`
              : sanitizedData?.length < minCharsInBody &&
                sanitizedData?.length !== 0
              ? `Body must be at least ${minCharsInBody} characters long.`
              : null
          setError(headerError)
        }}
        className={classNames('resize-none border-radius-5', {
          'disabled-input': disabled,
        })}
        disabled={disabled}
        config={editorConfiguration}
      />
      <div
        className={classNames({
          'd-flex justify-content-between': error,
          'd-flex justify-content-end': !error,
        })}>
        {error && <span className='font-open-sans text-error'>{error}</span>}
        <ShowCharsLimt
          limit={maxCharsInBody}
          enteredChars={totalCharsInBodyText}
          wrapperClasses='mb-4'
        />
      </div>
    </>
  )
}

export default CustomBody
